var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisOrganiserLot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,10.5c-0.2,0-0.3,0.1-0.4,0.2l-1.1,1.1l2.2,2.2l1-1c0.2-0.2,0.2-0.6,0-0.9L22,10.8C21.9,10.6,21.7,10.5,21.5,10.5  M19.6,12.4l-6.4,6.3v2.2h2.2l6.4-6.4L19.6,12.4 M21.6,7.3v0.1l-2.1,2.1V7.3H2.6v10.5H11v2.1H2.6c-1.2,0-2.1-0.9-2.1-2.1V5.2 c0-1.2,0.9-2.1,2.1-2.1h6.3L11,5.2h8.4C20.6,5.1,21.5,6.1,21.6,7.3C21.5,7.2,21.5,7.3,21.6,7.3L21.6,7.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisOrganiserLot);
export default __webpack_public_path__ + "static/media/action_gris_organiser-lot.a16a235a.svg";
export { ForwardRef as ReactComponent };